import { SELECIONAR_RESERVAS_MARCACAO } from '../types'

export default function selecionarReservasRemarcacao (reservas) {
  return {
    type: SELECIONAR_RESERVAS_MARCACAO,
    payload: reservas
  }
}
